<template>
  <section class="about-us-section pb-100 bg-dark text-white">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <!-- Текстовая часть -->
        <div class="col-md-12 col-lg-6">
          <div class="video-promo-content mb-md-4 mb-lg-0">
            <h2 class="section-title">{{ $t('about.title') }}</h2>
            <p class="section-description">{{ $t('about.description') }}</p>

            <ul class="list-unstyled tech-feature-list">
              <li class="py-1">
                <span class="ti-control-forward mr-2 color-secondary"></span>
                {{ $t('about.features.evaluation') }}
              </li>
              <li class="py-1">
                <span class="ti-control-forward mr-2 color-secondary"></span>
                {{ $t('about.features.forecast') }}
              </li>
              <li class="py-1">
                <span class="ti-control-forward mr-2 color-secondary"></span>
                {{ $t('about.features.analytics') }}
              </li>
              <li class="py-1">
                <span class="ti-control-forward mr-2 color-secondary"></span>
                {{ $t('about.features.tools') }}
              </li>
            </ul>
          </div>
        </div>

        <!-- Картинка -->
        <div class="col-md-12 col-lg-6">
          <div class="image-wrap">
            <img
              src="/assets/hero-single-img-1.svg"
              alt="Estimator illustration"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style scoped>
.about-us-section {
  background-color: #1e1e1e; /* тёмный фон */
}

.section-title,
.section-description,
.tech-feature-list li {
  color: #ffffff !important; /* белый текст */
}
</style>
